import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
//import google from "vue2-google-maps";

Vue.use(Vuex);
//var map = new google.maps.Map(document.getElementById("map"));
//var service = new google.maps.places.PlacesService(map);

export default {
  namespaced: true,
  state: {
    googleSearchPlaces: [],
    userPlaces: []
  },
  getters: {
    googleSearchPlaces(state) {
      return state.googleSearchPlaces;
    },
    userPlaces(state) {
      return state.userPlaces;
    }
  },
  actions: {
    //asynchronous or synchronus
    getGoogleSearchPlaces({ commit }, textinput) {
      return new Promise((res, rej) => {
        const request = {
          query: textinput,
          fields: ["formatted_address", "name", "geometry"]
        };
        service.textSearch(request, function(results, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            commit("UPDATE_GOOGLE_SEARCH_PLACES", { places: results });
            res(results);
          }
        });
      });
    },
    getListPlaces({ commit, rootState }) {
      const db = firebase.firestore();
      let docPlaces = db
        .collection("users")
        .doc(rootState.user.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");

      docPlaces
        .get()
        .then(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            let items = [...doc.data().items];
            let places = items.filter(el => el.info.placename && el.place);
            places = places.map(el => {
              return {
                ...el,
                name: el.info.placename,
                formatted_address: el.place.address1
              };
            });
            commit("SET_USER_PLACES", places);
          } else {
            commit("SET_USER_PLACES", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
          console.error("Error get tools: ", error);
        });
    }
  },
  mutations: {
    //synchronous
    UPDATE_GOOGLE_SEARCH_PLACES(state, { places }) {
      state.googleSearchPlaces = places;
    },
    SET_USER_PLACES(state, userPlaces) {
      if (userPlaces.length) {
        state.userPlaces = userPlaces;
      } else {
        state.userPlaces = [];
      }
    }
  }
};
